import { cn } from '../lib/cn.js';
import { teinte } from '../lib/teinte.js';

interface BarRowProps {
  label: string;
  count: number;
  possible: number;
  color: string;
  // false = period entirely before the habit existed → "not tracked yet"
  tracked: boolean;
}

// `.jauge` du kit, à la teinte de l'habitude (`--jauge-teinte`).
export function BarRow({ label, count, possible, color, tracked }: BarRowProps): React.ReactElement {
  const ratio = possible > 0 ? count / possible : 0;
  // Keep a sliver visible for any non-zero ratio so a 1/7 week doesn't vanish.
  const pct = ratio === 0 ? 0 : Math.max(8, Math.round(ratio * 100));

  return (
    <div
      className="flex items-center gap-3"
      role="img"
      aria-label={tracked ? `${label}, ${count} of ${possible} days` : `${label}, not tracked yet`}
    >
      <span className="ligne-repere w-16">{label}</span>
      <div
        className={cn('jauge flex-1', !tracked && 'opacity-40')}
        style={
          { ...teinte(color, '--jauge-teinte'), '--valeur': tracked ? pct : 0 } as React.CSSProperties
        }
      />
      <span className="ligne-repere w-10 text-right">{tracked ? `${count}/${possible}` : '—'}</span>
    </div>
  );
}
